<template>
  <div id="start" class="vue-rqf-page b2b">

    <youtube v-if="0 && !$root.partnerId" id="youtubeOpqBackground" class="youtubeWrap" @playing="onVideoPlaying" @ready="onPlayerReady" :video-id="videoId" :player-vars="videoVars"></youtube>

    <v-runtime-template v-if="startContent" :template="startContent"/>
    <div v-else class="startContent">

      <h2 class="entry-title">Få “hurtig-takst” nå</h2>

      <start-actions></start-actions>

      <p v-if="$root.isGuestPage()">Utbedre skaden på bilen og få en sakkyndig vurdering.</p>
      
    </div>
  </div>
</template>

<script>

import VRuntimeTemplate from "v-runtime-template";
import StartActions from './tags/StartActions.vue';

export default {
  data () {
    return {
      videoId: "mtS6xjBJwG8",
      videoVars: {
        controls: 0,
        iv_load_policy: 3,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
      },
      section: {
        start: 20,
        end: 30,
        timeoutInstance: null
      },
      startContent: window.mpsStartContent ? `` + window.mpsStartContent + `` : null
    }
  },
  components: {
      StartActions,
      VRuntimeTemplate
  },
  beforeCreate: function(){
    //console.log(this);

  },
  created: function(){
    console.log(this.$route.params);
    if(this.$route.params.license){
      this.$store.commit('setItem', {type: 'request', item: 'car_id', val: this.$route.params.license})
      this.$root.getCarModel();
    }

    //this.initYouTubeIframeAPI(); console.log( player )
  },
  mounted: function(){
    /*
    let self = this
    var checkYT = setInterval(function () {
      if(window.YT && window.YT.loaded){
        //self.onYouTubeIframeAPIReady();
        clearInterval(checkYT);
      }
    }, 100);
    */
  },
  methods: {
    onVideoPlaying(  ) {
      document.getElementById("youtubeOpqBackground").style.display = "block";
    },
    onPlayerReady( player ) {
      this.player = player
      this.player.mute();
      this.player.seekTo(this.section.start);
      this.player.playVideo();
      this.restartVideoSection();
    },
    restartVideoSection() {
      var duration = this.section.end - this.section.start;
      this.player.seekTo(this.section.start);
      this.section.timeoutInstance = setTimeout(this.restartVideoSection, duration * 1000);
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Start.vue?59f28ebd